import React, { useState, useEffect, useContext } from 'react';
import { LayoutContext } from '../../context/layoutContext';

import { RiUserSettingsLine } from 'react-icons/ri';

import Dialog from '../../components/Dialog';
import { getCookie, removeCookie } from '../../helpers/cookies';
import { getData, UpdateData } from '../../constants/api_index';
import { VALIDATECODE } from '../../constants/index';
import { DicodeDialog } from '../../styles/layOutStyles';

import Alert from '../../helpers/Alert';
import { Button } from '../../styles/commonStyles';
import CustomLoading from '../../pages/common/CustomLoading';
import { logOut } from '../../components/Topbar';

const DiCheck = ({ open, userInfo }) => {
  const { matchese } = useContext(LayoutContext);

  const [noDicode, setNoDicode] = useState(false);

  useEffect(() => {
    let delay;

    // SNS 로그인 회원 본인인증..
    if (noDicode) {
      delay = setInterval(() => {
        let auth = getCookie('ftv_auth');
        if (auth) {
          if (auth?.name) {
            clearInterval(delay);
            let body = {
              id: userInfo?.id,
              name: auth?.name,
              hp: auth?.hp,
              diCode: auth?.diCode,
            };

            UpdateData('user/dihp', body).then(res => {
              if (res?.data?.code == 200) {
                // [Req] 2023.09.07 무료이용권 지급 중지
                // eventVoucherAdd(body?.id);
                Alert('가입완료 🎉', '가입을 축하드립니다.', '', '', res => {
                  window.location.reload();
                });
                // window.location.reload();
              }
            });
          } else {
            clearInterval(delay);
            removeCookie('ftv_auth');
            setNoDicode(false);
            Alert('', '인증에 실패하였습니다. <br /> 잠시 후 다시 시도해주세요.');
            return;
          }
        }
      }, [1000]);
    }

    return () => clearInterval(delay);
  }, [noDicode]);

  const submit = () => {
    if (userInfo && !userInfo[VALIDATECODE]) {
      setNoDicode(false);
      setNoDicode(true);
      getData('payletter/auth?userId=hpAuth&userName=hpAuth').then(res => {
        let url;

        if (matchese) url = res?.value?.mobileUrl;
        else url = res?.value?.redirectUrl;

        let popOption = `width=430, height=555, resizable=no, scrollbars=no`;
        let popup = window.open(url, 'auth', popOption);

        try {
          popup.focus();
        } catch (e) {
          Alert('', '팝업이 차단되어 있습니다. <br /> 팝업 해제 후 이용 가능합니다.');
          setNoDicode(false);
        }
      });
      return;
    }
  };

  const eventVoucherAdd = async userId => {
    let param = {
      userId: userId,
    };

    UpdateData('user/welcome', param).then(res => {
      if (res?.data?.code === 200) {
        Alert('가입완료 🎉', '가입을 축하드립니다. <br /> 회원가입 이벤트 이용권이 발급되었습니다.', '', '', res => {
          window.location.reload();
        });
      }
    });
  };

  return (
    <Dialog open={open}>
      <DicodeDialog>
        <RiUserSettingsLine />
        <p>본인인증 후 이용가능합니다.</p>

        <Button onClick={submit}>인증하기</Button>

        <span>
          <b>* </b>인증 미확인 시 사이트 이용이 불가능합니다.
        </span>
        <span>
          <b>* </b>인증을 원치 않을 시 <u onClick={() => logOut(userInfo)}>로그아웃</u>이 가능합니다.
        </span>
        <span>
          <b>* </b>인증이 완료되기 전 페이지를 벗어날 시 정상적으로 진행이 되지 않을 수 있습니다.
        </span>
        {noDicode && <CustomLoading />}
      </DicodeDialog>
    </Dialog>
  );
};

export default DiCheck;
